import React, { ReactElement } from "react";
import { Bar } from "react-chartjs-2";
import AttributeScoreCell from "../../shared/AttributeScoreCell";

const options = {
  responsive: false,
  legend: {
    display: false,
  },
  scales: {
    yAxes: [
      {
        ticks: {
          min: 2,
          max: 10,
          stepSize: 2,
        },
      },
    ],
  },
  fill: false,
};

export default function ItemSpecificFactorScore2(): ReactElement {
  return (
    <>
      <h5 className="p-3 text-center">
        団体内での報酬による因子得点平均値の比較
      </h5>
      <div className="flex flex-row justify-center items-center flex-wrap">
        <div className="p-2 w-full lg:w-1/3 flex justify-center">
          <div>
            <Bar
              height={320}
              width={320}
              data={{
                labels: ["", "", ""],
                datasets: [
                  {
                    // barThickness: 10,
                    label: "有給である",
                    data: [9.1, 5.83, 7.92],
                    borderColor: "#FEFF02",
                    backgroundColor: "#FEFF02",
                  },
                  {
                    // barThickness: 10,
                    label: "有給でない",
                    data: [6.38, 5.67, 8.21],
                    borderColor: "#F5A300",
                    backgroundColor: "#F5A300",
                  },
                  {
                    // barThickness: 10,
                    label: "わからない",
                    data: [0, 0, 0],
                    borderColor: "#92D050",
                    backgroundColor: "#92D050",
                  },
                ],
              }}
              options={options}
            />
            <div className="flex justify-around text-xs">
              <div>理念共感と貢献意欲</div>
              <div>自己有用感</div>
              <div>居心地の良さ</div>
            </div>
          </div>
        </div>
        <div className="w-full lg:w-2/3 flex justify-center">
          <div className="px-3 w-full">
            <table className="table-auto w-full">
              <thead>
                <tr>
                  <th className="border font-normal text-sm px-2"></th>
                  <th className="border font-normal text-sm px-2">
                    理念共感と貢献意欲
                  </th>
                  <th className="border font-normal text-sm px-2">
                    自己有用感
                  </th>
                  <th className="border font-normal text-sm px-2">
                    居心地の良さ
                  </th>
                </tr>
              </thead>
              <tbody>
                {[
                  {
                    title: "あり",
                    color: "#FEFF02",
                    answeredCount: 10,
                    point1: 9.1,
                    point2: 5.83,
                    point3: 7.92,
                  },
                  {
                    title: "なし",
                    color: "#F5A300",
                    answeredCount: 10,
                    point1: 9.38,
                    point2: 5.67,
                    point3: 8.21,
                  },
                  {
                    title: "わからない",
                    color: "#92D050",
                    answeredCount: 0,
                    point1: 0,
                    point2: 0,
                    point3: 0,
                  },
                ].map((d) => (
                  <tr key={d.title}>
                    <td className="border px-4 py-2 text-sm text-center">
                      <div className="flex items-center">
                        <div
                          className="rounded h-3 w-3"
                          style={{ backgroundColor: d.color }}
                        />
                        <div className="ml-2">{d.title}</div>
                      </div>
                    </td>
                    <AttributeScoreCell
                      answeredCount={d.answeredCount}
                      point={d.point1}
                      averagePoint={9.31}
                      className="border px-2 text-center"
                    />
                    <AttributeScoreCell
                      answeredCount={d.answeredCount}
                      point={d.point2}
                      averagePoint={5.71}
                      className="border px-2 text-center"
                    />
                    <AttributeScoreCell
                      answeredCount={d.answeredCount}
                      point={d.point3}
                      averagePoint={8.14}
                      className="border px-2 text-center"
                    />
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </>
  );
}
